import React from 'react';
// @ts-ignore
import EmptyState from '../../../assets/empty-list-icon.svg';
import './no-billing-profile.scss';

export const NoEntitlement = () => {
  return (
    <div className="flex-column justify-center align-center no-entitlement pa-32">
      {/* @ts-ignore */}
      <img src={EmptyState} alt="No entitlement" width="56px" height="52px" />
      <p className="no-entitlement-description mt-16">No sites or subscriptions found</p>
    </div>
  );
};
